import {Common} from 'uchet.main.common';
import {Sso} from 'uchet.main.sso';

export {
	Main,
};

/**
 * @memberof BX.Uchet
 */
export default class Main
{
    commonInstance;
    ssoInstance;

	constructor(){
        this.commonInstance = new Common;
        this.ssoInstance = new Sso;
    }
}